/**
 * Centralized API Configuration
 * 
 * Environment options:
 * - 'local': localhost:5000 (for local development)
 * - 'server': Amazon EC2 (for testing on the server)
 * - 'production': rsapipeline.click (for production)
 * 
 * Usage in components:
 * import { baseApi, API_BASE_URL, ENVIRONMENT } from '../API/api';
 * 
 * Example:
 * const response = await axios.post(`${baseApi}/api/endpoint`, data);
 */
// Environment configuration
// For local development, change this value manually
// For production builds (npm run build), this will automatically be set to 'production'
const DEV_ENVIRONMENT = 'production'; // Options: 'local', 'server', 'production'

// Automatically use 'production' when building for production
// This ensures npm run build always uses production, regardless of DEV_ENVIRONMENT value
const ENVIRONMENT = process.env.NODE_ENV === 'production' ? 'production' : DEV_ENVIRONMENT;

const PS_SOURCE_URL = 'server'; // Options: 'local' (manual URL entry) or 'server' (fetch from AWS Secrets Manager)

// Local Development URLs (localhost)
const LOCAL_APIS = {
  baseApi: 'http://localhost:5000',
  serviceApi: 'http://localhost:5005',
  dividerApi: 'http://localhost:5000',
  carRemovalApi: 'http://localhost:5005',
  horizontalApi: 'http://localhost:5005',
  ManagerlApi: 'http://localhost:5000',
  EmbankmentReportApi: 'http://localhost:5005'
};

// Server URLs (Amazon EC2)
const SERVER_APIS = {
  baseApi: 'http://ec2-35-170-107-223.compute-1.amazonaws.com:5000',
  serviceApi: 'http://ec2-35-170-107-223.compute-1.amazonaws.com:5005',
  dividerApi: 'http://ec2-44-215-243-199.compute-1.amazonaws.com:5000',
  carRemovalApi: 'http://ec2-3-85-66-157.compute-1.amazonaws.com:5005',
  horizontalApi: 'http://ec2-44-215-243-199.compute-1.amazonaws.com:5005',
  ManagerlApi: 'http://ec2-54-88-46-250.compute-1.amazonaws.com:5000',
  EmbankmentReportApi: 'http://ec2-35-170-107-223.compute-1.amazonaws.com:5005'
};

// Production URLs (123bimlive.com - unified domain for all services)
const PRODUCTION_APIS = {
  baseApi: 'https://www.123bimlive.com',
  serviceApi: 'https://www.123bimlive.com',
  dividerApi: 'https://www.123bimlive.com',
  carRemovalApi: 'https://www.123bimlive.com',
  horizontalApi: 'https://www.123bimlive.com',
  ManagerlApi: 'https://www.123bimlive.com',  // Manager service runs through CloudFront
  EmbankmentReportApi: 'https://www.123bimlive.com'
};

// Select APIs based on environment
let APIS;
switch (ENVIRONMENT) {
  case 'local':
    APIS = LOCAL_APIS;
    break;
  case 'server':
    APIS = SERVER_APIS;
    break;
  case 'production':
    APIS = PRODUCTION_APIS;
    break;
  default:
    console.warn(`Unknown environment: ${ENVIRONMENT}, defaulting to local`);
    APIS = LOCAL_APIS;
}

// Export individual APIs
export const baseApi = APIS.baseApi;
export const serviceApi = APIS.serviceApi;
export const dividerApi = APIS.dividerApi;
export const carRemovalApi = APIS.carRemovalApi;
export const horizontalApi = APIS.horizontalApi;
export const ManagerlApi = APIS.ManagerlApi;
export const EmbankmentReportApi = APIS.EmbankmentReportApi;

// For relative URL requests, we need to use the baseApi as the base URL
// This ensures that relative URLs like '/api/projects' resolve to the correct backend
export const API_BASE_URL = baseApi;

// Debug logging
console.log('🔧 API Configuration Debug:');
console.log('🔧 ENVIRONMENT:', ENVIRONMENT);
console.log('🔧 APIS object:', APIS);
console.log('🔧 baseApi:', baseApi);
console.log('🔧 API_BASE_URL:', API_BASE_URL);
console.log('🔧 LOCAL_APIS.baseApi:', LOCAL_APIS.baseApi);
console.log('🔧 PRODUCTION_APIS.baseApi:', PRODUCTION_APIS.baseApi);

// Export the environment flag for reference
export { ENVIRONMENT, PS_SOURCE_URL };
